import { useState } from 'react';

export const useMutation = ({ mutationFn }: { mutationFn }) => {
  const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
  };
  const [mutationState, setMutationState] = useState({ ...initialState });

  return {
    ...mutationState,
    reset: () => setMutationState({ ...initialState }),
    mutateAsync: async (...params) => {
      setMutationState({
        isLoading: true,
        isSuccess: false,
        isError: false,
      });

      try {
        await mutationFn(...params);
        setMutationState({
          isLoading: false,
          isSuccess: true,
          isError: false,
        });
      } catch (err) {
        setMutationState({
          isLoading: false,
          isSuccess: false,
          isError: true,
        });
      }
    },
  };
};
